import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IRolesPanelButtonProps } from './types';
import { BOARD_SECTION_ROLES_TITLE } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function RolesPanelButton ({
    indicatorNumber,
    isEssentialFeature,
    tooltip,
    onClick
}: IRolesPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.ROLES}
            indicatorNumber={indicatorNumber}
            isEssentialFeature={isEssentialFeature}
            title={BOARD_SECTION_ROLES_TITLE}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.ROLES);
                onClick();
            }}
        />
    );
}
